import React from "react";
import { useTranslation } from "react-i18next";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer
} from "recharts";

function SLAChartEscalation({ data }) {
  const { t } = useTranslation();

  if (!data) {
    return (
      <div className="p-3 bg-white rounded-4 shadow-sm">
        {t("sla.chart.no_escalation", "No escalation data")}
      </div>
    );
  }

  const rows = [
    { level: t("sla.level.l0", "Level 0"), value: data.level_0 || 0 },
    { level: t("sla.level.l1", "Level 1"), value: data.level_1 || 0 },
    { level: t("sla.level.l2", "Level 2"), value: data.level_2 || 0 },
    { level: t("sla.level.l3", "Level 3"), value: data.level_3 || 0 },
  ];

  return (
    <div className="bg-white rounded-4 shadow-sm p-4" style={{ height: 350 }}>
      <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>
        {t("sla.charts.escalation", "Escalation Levels")}
      </div>

      <ResponsiveContainer>
        <BarChart data={rows}>
          <XAxis dataKey="level" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="value" fill="#0096D2" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SLAChartEscalation;
